const PRINT_PAGE_SELECTOR = '.print-a4-landscape';

function waitForCaptureLayout(): Promise<void> {
  return new Promise(resolve => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => resolve());
    });
  });
}

export async function renderSinglePrintPageToPng(root: HTMLElement): Promise<Blob> {
  const pages = Array.from(root.querySelectorAll<HTMLElement>(PRINT_PAGE_SELECTOR));
  if (pages.length !== 1) {
    throw new Error(`Screenshot capture requires exactly one print page; found ${pages.length}.`);
  }

  const page = pages[0];
  root.classList.add('print-root--capture');
  page.classList.add('print-a4-landscape--capture');

  try {
    await waitForCaptureLayout();
    const { toBlob } = await import('html-to-image');
    const blob = await toBlob(page, {
      backgroundColor: '#ffffff',
      cacheBust: true,
      pixelRatio: 2
    });

    if (!blob) throw new Error('The print page could not be rendered as a PNG.');
    return blob;
  } finally {
    page.classList.remove('print-a4-landscape--capture');
    root.classList.remove('print-root--capture');
  }
}
